import React from 'react';
import { Outlet } from 'react-router-dom';

import './Receive.scss';

const Receive = () => {
	return (
		<div className='Receive'>
			<Outlet />
		</div>
	);
};

export default Receive;
